<!-- suppress HtmlUnknownTag -->
<!--
  @@@@@@@@@@@@@@@@@@@@@ USE THE ALIAS @@@@@@@@@@@@@@@@@@@@@@

  Done as a wrapper, just because WebStorm shows a warning every time the
  `font-awesome` tag is used, and this just limit the number of warnings.
  I was not able to load the tag globally so it would not show the warning,
  so this is was the easiest alternative.

  Here are the docs if we want to extend it to do to more
  https://www.npmjs.com/package/@nuxtjs/fontawesome

  May want to do some extra work to check the type and either load Imgix vs FontAwesome
-->
<template>
  <font-awesome-icon :icon="name" />
</template>

<script>
import { FontAwesomeIcon, } from '@fortawesome/vue-fontawesome';

export default {
  name: 'Icon',
  components: { FontAwesomeIcon },
  props: {
    name: {
      type: [
        Array,
        String,
      ],
      required: true,
    },
  },
};
</script>
